import { ComponentPropsWithoutRef, FC } from 'react';

type DownloadIconProps = ComponentPropsWithoutRef<'svg'>;

export const DownloadIcon: FC<DownloadIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            width="11"
            height="12"
            viewBox="0 0 11 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M5.41504 9.1546L2.16908 5.90465L2.87579 5.23079L4.91746 7.27246V0H5.91663V7.27246L7.95829 5.23079L8.665 5.90465L5.41504 9.1546ZM1.2486 11.8301C0.899979 11.8301 0.604722 11.7081 0.362833 11.4641C0.120944 11.2202 0 10.9238 0 10.575V9.35494H0.999166V10.5745C0.999166 10.6386 1.02588 10.6974 1.07931 10.7508C1.13273 10.8042 1.19149 10.8309 1.2556 10.8309H9.57448C9.63859 10.8309 9.69735 10.8042 9.75077 10.7508C9.8042 10.6974 9.83092 10.6386 9.83092 10.5745V9.35494H10.8301V10.575C10.8301 10.9238 10.708 11.2202 10.4639 11.4641C10.2198 11.7081 9.92337 11.8301 9.57473 11.8301H1.2486Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
